import { render, staticRenderFns } from "./Wrench.vue?vue&type=template&id=09e8a45f"
import script from "./Wrench.vue?vue&type=script&lang=js"
export * from "./Wrench.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports